import { getActivationTypeLabel } from "../../Constants";

import Selector from "./Selector";

export const activationTypeTypes = [
  { title: "manual", value: "manual" },
  { title: "auto", value: "auto" },
];

export default function ActivationTypeSelector({ value, language, onChange }) {
  return (
    <Selector
      options={activationTypeTypes}
      value={value}
      onChange={onChange}
      className="activation-type"
      getOptionLabel={(option) => getActivationTypeLabel(option.title, language)}
    />
  );
}
